"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RdfsLiteral = void 0;
const models_1 = require("lincd/lib/models");
const rdfs_1 = require("../ontologies/rdfs");
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
let RdfsLiteral = class RdfsLiteral extends Shape_1.Shape {
    constructor(node) {
        super(node);
    }
    get node() {
        return this._node;
    }
    get value() {
        return this.node.value;
    }
    get uriResource() {
        return null;
    }
};
exports.RdfsLiteral = RdfsLiteral;
RdfsLiteral.targetClass = rdfs_1.rdfs.Literal;
RdfsLiteral.preferredNodeKind = models_1.Literal;
exports.RdfsLiteral = RdfsLiteral = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [models_1.Literal])
], RdfsLiteral);
//# sourceMappingURL=RdfsLiteral.js.map